export const ACCEPTED = 'ACCEPTED';
export const ACCEPTED_BY_PRIMARY_CONTRACTOR = 'ACCEPTED_BY_PRIMARY_CONTRACTOR';
export const ACCEPTED_WITH_ALBUM = 'ACCEPTED_WITH_ALBUM';
export const CALL = 'CALL';
export const DONE = 'DONE';
export const DRAFT = 'DRAFT';
export const EXPLOITATION = 'EXPLOITATION';
export const IN_PROGRESS = 'IN_PROGRESS';
export const NOT_ACCEPTED = 'NOT_ACCEPTED';
export const NOT_ASSIGNED = 'NOT_ASSIGNED';
export const NOT_READY = 'NOT_READY';
export const NOT_APPROVED = 'NOT_APPROVED';
export const NULL = 'NULL';
export const RE_CALL = 'RE_CALL';
export const READY = 'READY';
export const TESTING = 'TESTING';
export const TODO = 'TODO';

export enum Statuses {
  ACCEPTED = 'ACCEPTED',
  ACCEPTED_BY_PRIMARY_CONTRACTOR = 'ACCEPTED_BY_PRIMARY_CONTRACTOR',
  ACCEPTED_WITH_ALBUM = 'ACCEPTED_WITH_ALBUM',
  CALL = 'CALL',
  DONE = 'DONE',
  DRAFT = 'DRAFT',
  EXPLOITATION = 'EXPLOITATION',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_ACCEPTED = 'NOT_ACCEPTED',
  NOT_ASSIGNED = 'NOT_ASSIGNED',
  NOT_READY = 'NOT_READY',
  NOT_APPROVED = 'NOT_APPROVED',
  NULL = 'NULL',
  RE_CALL = 'RE_CALL',
  READY = 'READY',
  TESTING = 'TESTING',
  TODO = 'TODO',
}
